// src/components/Admin/Leads/LeadCard.jsx
import React from "react";
import { Draggable } from "@hello-pangea/dnd";

export function LeadCard({ lead, index, onClick }) {
  const draggableId = String(lead.id);

  // Formatear nombre: primera letra mayúscula, resto minúscula
  const formatName = (name) => {
    if (!name) return "";
    return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
  };

  // Calcular días transcurridos desde created_at
  const getDaysSinceCreated = (createdAt) => {
    if (!createdAt) return null;
    const createdDate = new Date(createdAt);
    const now = new Date();
    const diffMs = now - createdDate;
    return Math.floor(diffMs / (1000 * 60 * 60 * 24));
  };

  const days = getDaysSinceCreated(lead.created_at);
  const isOld = days != null && days > 20;

  // Link de WhatsApp
  const cleanPhone = (lead.contact_phone || "").replace(/\D/g, "");
  const whatsappUrl = cleanPhone ? `https://wa.me/${cleanPhone}` : null;

  return (
    <Draggable draggableId={draggableId} index={index}>
      {(provided, snapshot) => (
        <div
          onClick={() => onClick?.(lead)}
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          style={{
            userSelect: "none",
            padding: 12,
            marginBottom: 8,
            borderRadius: 10,
            background: "#fff",
            border: "1px solid #eee",
            boxShadow: snapshot.isDragging
              ? "0 6px 20px rgba(0,0,0,0.15)"
              : "0 1px 3px rgba(0,0,0,0.08)",
            fontSize: 13,
            ...provided.draggableProps.style,
          }}
        >
          {/* Primera fila: nombre y valor estimado */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 4,
            }}
          >
            <div style={{ fontWeight: 600, fontSize: 14 }}>
              {formatName(lead.title)}
            </div>

            {lead.estimated_value != null && (
              <div
                style={{
                  fontSize: 11,
                  padding: "2px 6px",
                  borderRadius: 999,
                  background: "#f5f5f5",
                  fontWeight: 500,
                }}
              >
                S/ {Number(lead.estimated_value).toFixed(2)}
              </div>
            )}
          </div>

          {/* Empresa / fuente */}
          <div style={{ marginBottom: 4 }}>
            {lead.company_name && (
              <div style={{ fontSize: 12, opacity: 0.8 }}>
                {lead.company_name}
              </div>
            )}
            {lead.source?.name && (
              <div style={{ fontSize: 11, opacity: 0.7 }}>
                Fuente: {lead.source.name}
              </div>
            )}
          </div>

          {/* Email y teléfono */}
          <div style={{ marginBottom: 6 }}>
            {lead.contact_email && (
              <div style={{ fontSize: 11, opacity: 0.8 }}>
                📧 {lead.contact_email}
              </div>
            )}
            {lead.contact_phone && (
              <div style={{ fontSize: 11, opacity: 0.8 }}>
                📞 {lead.contact_phone}
              </div>
            )}
          </div>

          {/* Notas */}
          {lead.notes && (
            <div
              style={{
                fontSize: 11,
                opacity: 0.9,
                marginBottom: 6,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
              title={lead.notes}
            >
              {lead.notes}
            </div>
          )}

          {/* Footer: días + botón WhatsApp */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: 4,
            }}
          >
            {/* Indicador de días */}
            {days != null && (
              <div
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 4,
                  fontSize: 11,
                }}
              >
                <span
                  style={{
                    width: 8,
                    height: 8,
                    borderRadius: "50%",
                    backgroundColor: isOld ? "#000000" : "#4caf50",
                    display: "inline-block",
                  }}
                />
                <span
                  style={{
                    fontWeight: isOld ? 600 : 400,
                    color: isOld ? "#000000" : "#555",
                  }}
                >
                  {days} día{days === 1 ? "" : "s"} en el pipeline
                </span>
              </div>
            )}

            {/* Botón WhatsApp */}
            {whatsappUrl && (
              <a
                href={whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => e.stopPropagation()} // para que no dispare el onClick del card
                style={{
                  fontSize: 11,
                  padding: "4px 8px",
                  borderRadius: 999,
                  border: "none",
                  textDecoration: "none",
                  background: "#25D366",
                  color: "#fff",
                  fontWeight: 600,
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 4,
                }}
              >
                <span>WhatsApp</span>
              </a>
            )}
          </div>
        </div>
      )}
    </Draggable>
  );
}
